import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-update-permiso',
  templateUrl: './dialog-update-permiso.component.html',
  styleUrls: ['./dialog-update-permiso.component.css']
})
export class DialogUpdatePermisoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
